import { useQuery } from "react-query";
import { getAllMasterLegalEntity } from "../../../../actions/CarrierAgreementMgmt/Agreements";

export const useGetAllMasterLegalEntities = () => {
  return useQuery("getAllMasterLegalEntities", getAllMasterLegalEntity, {
    refetchOnWindowFocus: false,
  });
};
